<div class="tabs">
  @if (tabs) {
    <div class="tabs__fake-left-rounded-corner"></div>
    <div class="tabs__fake-right-rounded-corner"></div>
    <mat-tab-group
      class="tabs__group"
      #tabGroup
      animationDuration="0"
      mat-stretch-tabs="false"
      preserveContent="true"
      cdkDropList
      cdkDropListOrientation="horizontal"
      cdkDropListLockAxis="x"
      [cdkDropListData]="tabs"
      (cdkDropListDropped)="onTabDrop($event)"
      (selectedIndexChange)="onTabIndexChange($event)">
      @for (tab of tabs; track tab.id; let index = $index) {
        <mat-tab>
          <ng-template matTabLabel>
            <div
              cdkDrag
              cdkDragRootElement=".mat-mdc-tab"
              [cdkDragDisabled]="tab.predefined"
              cdkDragPreviewClass="preview"
              cdkDragBoundary=".tabs__group"
              [ngClass]="{ 'tabs__group--draggable': !tab.predefined }">
              {{ tab.name }}
              @if (!tab.predefined) {
                <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
              }
            </div>
          </ng-template>
          <ng-template matTabContent>
            <ng-container *ngTemplateOutlet="tableTemplate; context: { tab, index }"></ng-container>
          </ng-template>
        </mat-tab>
      }
      @if (type !== 'Archive') {
        <mat-tab>
          <ng-template mat-tab-label>
            <span style="font-size: 24px" class="material-symbols-outlined">add_box</span>
          </ng-template>
        </mat-tab>
      }

      <ng-template #tableTemplate let-tab="tab" let-index="index">
        <app-utils-table [tab]="tab" [tabIndex]="index" [type]="type"></app-utils-table>
      </ng-template>
    </mat-tab-group>
  } @else {
    <app-utils-tabs-skeleton></app-utils-tabs-skeleton>
  }
</div>
